import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Alert, Badge, Card, CardContent, PageLoading } from "@dosa/ui";
import { listPharmacists } from "../../lib/api-client";

export function AdminPharmacistsPage() {
  const { t } = useTranslation();
  const { data: pharmacists, isLoading } = useQuery({ queryKey: ["pharmacists"], queryFn: listPharmacists });

  if (isLoading) return <PageLoading />;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.pharmacists.title")}</h1>
      <Alert variant="info">{t("admin.pharmacists.verificationNotice")}</Alert>
      <Card>
        <CardContent className="p-0">
          <ul className="divide-y divide-charcoal-100">
            {pharmacists?.map((p) => (
              <li key={p.id} className="flex items-center justify-between px-5 py-4">
                <div>
                  <p className="font-medium text-charcoal-800">
                    {p.firstName} {p.lastName}
                  </p>
                  <p className="text-sm text-charcoal-400">
                    {t("admin.pharmacists.licenseNumber")}: {p.licenseNumber}
                  </p>
                </div>
                <Badge variant={p.status === "ACTIVE" ? "success" : "neutral"}>{p.status}</Badge>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
